import React from "react";
import CreatableSelect from "react-select/creatable";
import { Form, Input } from "../../../../_core/_components";
import { EditTipoDividaProperty } from "./reducer";
import { DocumentTypeField, DocumentTypeLabel } from "./styles";

type Props = {
  form: any;
  dispatch: React.Dispatch<{
    type: EditTipoDividaProperty;
    payload: any;
  }>;
};

const ModalContent: React.FC<Props> = ({ form, dispatch }: Props) => {
  const parseCreatableOptions = (value: string) =>
    value
      .split(";")
      .map((item) => item.trim())
      .filter(Boolean)
      .map((item) => ({ label: item, value: item }));

  const formatCreatableOptions = (
    options: readonly { label: string; value: string }[] | null
  ) =>
    options
      ?.map((option) => option.value.trim())
      .filter(Boolean)
      .join(";") ?? "";

  return (
    <Form
      columns={6}
      items={[
        <Input
          state={[
            form.nomeDivida,
            (value: React.SetStateAction<string>) =>
              dispatch({ type: "SET_NOME", payload: value }),
          ]}
          label="Nome"
        />,
        <Input
          state={[
            form.codigoContrato,
            (value: React.SetStateAction<string>) =>
              dispatch({ type: "SET_CODIGO_CONTRATO", payload: value }),
          ]}
          label="Código contrato"
        />,
        <DocumentTypeField>
          <DocumentTypeLabel>Tipo documento</DocumentTypeLabel>
          <CreatableSelect
            isMulti
            value={parseCreatableOptions(form.tipoDocumentos || "")}
            onChange={(options) =>
              dispatch({
                type: "SET_TIPO_DOCUMENTO",
                payload: formatCreatableOptions(options),
              })
            }
            placeholder="Digite e pressione Enter..."
            formatCreateLabel={(inputValue) => `Criar "${inputValue}"`}
          />
        </DocumentTypeField>,
        <DocumentTypeField>
          <DocumentTypeLabel>Tipo movimento</DocumentTypeLabel>
          <CreatableSelect
            isMulti
            value={parseCreatableOptions(form.tipoMovimentos || "")}
            onChange={(options) =>
              dispatch({
                type: "SET_TIPO_MOVIMENTO",
                payload: formatCreatableOptions(options),
              })
            }
            placeholder="Digite e pressione Enter..."
            formatCreateLabel={(inputValue) => `Criar "${inputValue}"`}
          />
        </DocumentTypeField>,
      ]}
    />
  );
};

export default ModalContent;
